module.exports = __webpack_public_path__ + "b5ef049fa425f08042461638e145f012.png";